export default __webpack_public_path__ + "0068d136b4f5ffc93f0073cf3ef223fd.png";